export const COPILOT_POPOVER_RELEASE_DATE = '2024-07-04';
